/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import { shallowEqual, useSelector } from 'react-redux';

const useIsMobile = () => useSelector(
  (state) => {
    return state.deviceInfo.isMobile || false;
  },
  shallowEqual
);

export default useIsMobile;